import type { TreemapEntry } from "./types";
import { posLabel } from "./pos-tag";

interface Props {
  entry: TreemapEntry;
  rank: number;
  density: "tiny" | "compact" | "full";
}

// The dictionary form is the only landmark. Reading and gloss live
// on the lifted card — the front of a parcel just names the place.
export function TileFront({ entry, rank, density }: Props) {
  return (
    <div className="n5-tile-inner relative h-full w-full p-1.5 sm:p-2">
      {density !== "tiny" && (
        <div className="n5-marginalia absolute top-1.5 right-1.5 flex gap-2 sm:top-2 sm:right-2">
          <span>{posLabel(entry.pos)}</span>
          <span>№ {rank.toString().padStart(3, "0")}</span>
        </div>
      )}

      <div
        className={
          density === "tiny"
            ? "h-full w-full"
            : "absolute right-1.5 bottom-1.5 left-1.5 flex flex-col sm:right-2 sm:bottom-2 sm:left-2"
        }
      >
        <span className="n5-landmark">{entry.display}</span>
      </div>
    </div>
  );
}
